import { BaseDto } from './base.dto';

export class MerchantFavoriteProductDto extends BaseDto {
  merchantFavoriteId: number;
  productId: number;
}
